import axios from 'axios';
import { Base64 } from 'js-base64';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import CheckIcon from '@mui/icons-material/Check';
import { getInspectionData } from '../../Redux/Actions/CommonActions';
import { origin } from '../../Config/Api-constants';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Grid, CircularProgress, Typography, Checkbox, FormControlLabel, Button, Divider } from '@mui/material';
import FilledButton from '../../Components/Button/FilledButton';
import LoadButton from '../../Components/Button/LoadButton';

const SelectedTemplateView = ({ template, onBack, setZeroState, handleClose }) => {
    const [keepMedia, setKeepMedia] = useState(false);
    const [keepData, setKeepData] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const storeData = useSelector((state) => state.CommonReducer);
    const dispatch = useDispatch();
    const [mergedTemplates, setMergedTemplates] = useState([]);

    const loadInspectionData = (guid) => {
        let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem('AC'));
        let sessionUserId = Base64.decode(sessionStorage.getItem('UI'));
        dispatch(getInspectionData({ guid: guid, associate_company: sessionAssociateCompanyKey, user_id: sessionUserId })); //line test
    };

    const fetchTemplateStatusCounts = async (inspectionGuid) => {
        setLoader(true);
        const baseUrl = await origin();
        const sessionAPIKey = sessionStorage.getItem("CK");
        const sessionSecretKey = sessionStorage.getItem("SK");
        try {
            const response = await axios({
                method: 'get',
                url: `${baseUrl}inspection/${inspectionGuid}/templates/status-counts`,
                headers: {
                    Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                    'api-key': `${Base64.decode(sessionAPIKey)}`,
                    'Content-Type': 'application/json',
                    "platform": 'web',
                    "api-platform": 'WRW',
                    "user_id": sessionStorage.getItem('UID'),
                    "product": sessionStorage.getItem('asoCom'),
                    "mode": 'online',
                },
            });
            setLoader(false);
            return response.data.data;
        } catch (error) {
            setLoader(false);
            console.error('Error fetching template status counts:', error);
            throw error;
        }
    };

    useEffect(() => {

        const fetchAndMergeTemplates = async () => {

            try {
                const statusCounts = await fetchTemplateStatusCounts(template?.orderGuid);
                const merged = template?.inspection_templates?.map(template => {
                    const status = statusCounts.find(s => s.template_id === template.template_id);
                    return {
                        ...template,
                        template_status: status?.template_status || { completeLines: 0, totalLines: 0 },
                    };
                });
                setMergedTemplates(merged);
            } catch (error) {
                console.error("Failed to merge template statuses:", error);
            }
        };

        fetchAndMergeTemplates();
    }, []);



    const handleSelect = (template) => {
        const exists = selectedTemplates.some(
            (t) => t.template_id === template.template_id
        );
        if (exists) {
            setSelectedTemplates((prev) =>
                prev.filter((t) => t.template_id !== template.template_id)
            );
        } else {
            setSelectedTemplates((prev) => [
                ...prev,
                template
            ]);
        }
    };



    const renderTemplateRow = (template) => {
        const isSelected = selectedTemplates.some(
            (t) => t.template_id === template.template_id
        );

        return (
            <Box
                key={template.template_id}
                onClick={() => handleSelect(template)}
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: `1px solid ${isSelected ? '#4282E2' : '#ccc'}`,
                    borderRadius: '6px',
                    padding: '12px',
                    backgroundColor: isSelected ? '#e3f2fd' : '#fff',
                    cursor: 'pointer',
                    mb: 1,
                }}
            >
                <Typography sx={{ fontSize: "17px" }}>{template?.name}</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* required later */}
                    {template?.is_pdf_template === 0 && <Typography sx={{ mr: 1 }}>
                        {template?.template_status?.completeLines}/{template?.template_status?.totalLines}
                    </Typography>}
                    {isSelected && <CheckIcon fontSize="small" color="primary" />}
                </Box>
            </Box>
        );
    };

    const postSelectedTemplates = async (selectedTemplates, orderId) => {
        const baseUrl = await origin();
        const sessionAPIKey = sessionStorage.getItem("CK");
        const sessionSecretKey = sessionStorage.getItem("SK");

        try {
            setLoading(true);
            const response = await axios({
                method: "post",
                url: `${baseUrl}inspection/import-templates`,
                headers: {
                    Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                    "api-key": `${Base64.decode(sessionAPIKey)}`,
                    "Content-Type": "application/json",
                    "platform": 'web',
                    "api-platform": 'WRW',
                    "user_id": sessionStorage.getItem('UID'),
                    "product": sessionStorage.getItem('asoCom'),
                    "mode": 'online',
                },
                data: {
                    order_id: orderId,
                    templates: selectedTemplates,
                    keep_data: keepData,
                    keep_media: keepMedia,
                    inspection_from: "ISN",
                    from_inspection_guid: template?.orderGuid,
                    guid: sessionStorage.getItem("guid")
                },
            });
            setLoading(false);
            console.log("Post successful:", response.data);
            handleClose()
            loadInspectionData(sessionStorage.getItem("guid"))
            setZeroState(false);

        } catch (error) {
            console.error("Error posting selected templates:", error);
            setLoading(false);
            throw error;
        }
    };


    const handleAdd = async () => {
        try {
            const orderId = storeData?.inspectionData?.data?.order_id;
            await postSelectedTemplates(selectedTemplates, orderId);
            // Show success or close modal
        } catch (err) {
            // error
        }
    };



    return (
        <Box sx={{ width: "100%", margin: 'auto', mt: 4 }}>
            <Box sx={{ width: "100%", height: "200px", overflowY: "scroll", px: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, border: '1px solid #ccc', p: 1, borderRadius: "8px" }}>
                    <ArrowBackIcon sx={{ mr: 1, cursor: "pointer" }} onClick={onBack} />
                    <Typography variant="body1">Order #{template?.orderId}</Typography>
                </Box>
                <Typography className='prev_deleted_lable'>IN REPORT</Typography>
                <br />
                {loader && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <CircularProgress size={24} />
                    </Box>
                )}
                {mergedTemplates?.filter(
                    (template) => !template.deleted_at
                )?.map(renderTemplateRow)}
                {mergedTemplates?.filter(
                    (template) => template.deleted_at
                )?.length > 0 && (
                        <>
                            <br />
                            <Typography className="prev_deleted_lable">PREVIOUSLY DELETED</Typography>
                            {mergedTemplates?.filter(
                                (template) => template.deleted_at
                            ).map(renderTemplateRow)}
                        </>
                    )}
            </Box>
            <br />
            <Box sx={{ mt: 1, px: 3 }}>
                <Divider />
                <Grid container spacing={2}>
                    {/* Keep Data */}
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={keepData}
                                    onChange={(e) => setKeepData(e.target.checked)}
                                />
                            }
                            label={
                                <Box sx={{ mt: 1 }}>
                                    <Typography className='keep-heading'>Keep data</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Maintains all checkboxes and selected comments in the report
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                alignItems: 'flex-start', // Aligns checkbox to top
                                '& .MuiFormControlLabel-label': {
                                    marginTop: '2px' // Optional: aligns text block with checkbox icon
                                }
                            }}
                        />
                    </Grid>
                    {/* Keep Media */}
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={keepMedia}
                                    onChange={(e) => setKeepMedia(e.target.checked)}
                                />
                            }
                            label={
                                <Box sx={{ mt: 1 }}>
                                    <Typography className='keep-heading'>Keep media</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Keeps all media already assigned in the report
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                alignItems: 'flex-start',
                                '& .MuiFormControlLabel-label': {
                                    marginTop: '2px'
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ mt: 3, textAlign: 'center' }}>
                <LoadButton
                    id="Import_Template"
                    width="320px"
                    loading={loading}
                    disabled={selectedTemplates?.length >= 1 ? false : true}
                    text="Add"
                    onClick={handleAdd}
                />
            </Box>
        </Box>
    );
};

export default SelectedTemplateView;
